<template>
  <div>
    <v-layout row>
      <GetDetailPage
        class="hidden-xs-only"
        :data="{
          tag: 'LINK',
          stag: this.getTreeMasterInfo.tag,
          sdid: this.getTreeMasterInfo.did,
          size: 'flat',
          item: this.getTreeMasterInfo}"
      />
      <GetTreePage
      v-if="
      this.getTreeParentInfo !== null &&
      this.getTreeParentInfo.did !== ''
      "
      :data="{
        tag: 'A1.P',
        type: null,
        item: null,
        did: this.getTreeParentInfo.did,
        size: 'icon'
        }"
      />
      <v-spacer/>
      <v-btn :color="ui.colorBlue" flat dark
      v-if="
      this.getTreeParentInfo !== null &&
      this.getTreeParentInfo.id !== ''"
      >
        <v-icon left :color="ui.colorBlue"> upgrade </v-icon>
          {{this.getTreeParentInfo.id}}
      </v-btn>
      <v-btn :color="ui.colorBlue" flat dark>
        <v-icon left :color="ui.colorBlue"> playlist_add </v-icon>
          {{this.getSearchResults.length}}
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import GetDetailPage from "@/support/detail/components/GetDetailPage";
import GetTreePage from "@/asset/tree/components/GetTreePage";

export default {
  components: {
    GetDetailPage,
    GetTreePage
  },
  mixins: [apptheme],
  data() {
    return {};
  },
  props: {
    date: {
      type: Object
    }
  },
  methods: {
    defineID(num) {
      return this.defineIDGShortLastSix(num);
    }
  },
  computed: {
    ...mapGetters([
      "getSearchResults",
      "getTreeInfo",
      "getTreeMasterInfo",
      "getTreeParentInfo"
    ])
  }
};
</script>
